<template>
  <div class="login-page">
    <div class="login-header">
      <div class="zer-log"></div>
    </div>
    <div class="choose-sys">
      <div
        style="margin-top:4%;display:inline-block;position:absolute;left:50%;transform:translate(-50%,0);"
      >
        <div class="zer-login">
          <ul class="log-tab">
            <!-- <li
              v-for="(item,index) in tabs"
              :key="index"
              :class="[{active:index == num},classes[index]]"
              @click="tab(index)">{{item}}
            </li>-->
            <li>联众远程医学影像教学系统V1.0</li>
          </ul>
          <transition name="login">
            <div v-if="!showForget" class="tabCon">
              <el-form
                :model="loginForm"
                :rules="rules"
                v-if="isTab"
                ref="loginForm"
                label-width="100px"
                class="loginForm"
              >
                <el-form-item prop="loginMobile">
                  <span class="iconfont icon-zhanghao loginIcon"></span>
                  <el-input
                    v-model="loginForm.loginMobile"
                    placeholder="请输入手机号"
                    :clearable="true"
                    :maxlength="userNameLen"
                    class="login-input"
                    @keyup.enter.native="login('loginForm')"
                    auto-complete="new-password"
                    name="loginMobile"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="loginPasswd">
                  <span class="iconfont icon-mima loginIcon"></span>
                  <el-input
                    v-model="loginForm.loginPasswd"
                    :maxlength="pwdlength"
                    placeholder="请输入密码"
                    class="login-input"
                    :clearable="true"
                    @keyup.enter.native="login('loginForm')"
                    type="password"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="checkCode">
                  <el-input
                    v-model="loginForm.checkCode"
                    :maxlength="vlength"
                    id="login-input-code"
                    class="input-code"
                    @keyup.enter.native="login('loginForm')"
                    placeholder="验证码"
                    :clearable="true"
                  ></el-input>
                  <img @click="_changeVerifyCode" :src="verifySrc" alt>
                </el-form-item>

                <el-button type="primary" @click="login('loginForm')">{{loadText}}</el-button>
                <div class="forgetPassword">
                  <span @click="showForget = true">忘记密码</span>
                </div>
              </el-form>
            </div>
          </transition>
          <transition name="forget">
            <div class="forget" v-if="showForget">
              <ForgetPassword :num="num" @closeForget="closeForget"></ForgetPassword>
            </div>
          </transition>
        </div>
        <div class="footer">
          <i class="foot-l">杭州联众医疗科技股份有限公司</i>
          <i class="foot-r">浙ICP备11059294号-3</i>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import http from "@/api/http";
import * as _ from "@/common/js/config";
import { cookies } from "@/api/util";
import { message } from "@/common/js/messages";
//引入忘记密码组件
import ForgetPassword from "./forget.vue";
export default {
  components:{ForgetPassword},
  data() {
    return {
      rules: {
        loginMobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号为11位", trigger: "blur" }
        ],
        loginPasswd: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        checkCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
        /*resource: [
            { required: true, message: '请选择活动资源', trigger: 'change' }
          ],*/
      },
      loginForm: {
        loginMobile: "",
        loginPasswd: "",
        checkCode: ""
      },
      nPassWordNum: 4,
      loading: false,
      loadText: "登录",
      tabs: ["远程诊断系统", "远程会诊系统", "远程教学系统"],
      tabContents: ["内容一", "内容二", "内容三"],
      classes: ["diagnosis", "consultation", "teaching"],
      imgUrl: ["", "", ""],
      tables: {
        background: "#000"
      },
      msg: "",
      loginMobile: "",
      loginPasswd: "",
      checkCode: "",
      //表单输入验证
      userNameLen: 11,
      pwdlength: 20,
      isTab: true,
      vlength: 4,
      num: 2,
      nTime: 300,
      /*show0:false,
        show1:false,
        show2:false,
        show3:false,*/
      verifySrc: `${window.BASE_URL}code.json?${Math.random()}`,
      showForget:false,//是否忘记密码
    };
  },
  mounted() {
    let bodyH = document.documentElement.scrollHeight;
    document.getElementsByTagName("body")[0].style.height = bodyH + "px";
    window.addEventListener("resize", () => {
      setTimeout(() => {
        let bodyH = document.documentElement.scrollHeight;
        document.getElementsByTagName("body")[0].style.height = bodyH + "px";
      }, 50);
    });
  },
  methods: {
    closeForget(){
      this.showForget=false;
      this._changeVerifyCode();
    },
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.loading) return;
          let params = {
            loginMobile: this.loginForm.loginMobile,
            loginPasswd: hex_md5(this.loginForm.loginPasswd),
            checkCode: this.loginForm.checkCode
          };
          http
            .get("/login.json", { params })
            .then(res => {
              this.loading = true;
              this.loadText = "登录中...";
              if (res.data.code === _.ERR_OK) {
                if (this.num == 2) {
                  //  this.$router.push({path:'/Homepage/HospitalImage',query:{'isSearch':false}})
                  this.$router.push({
                    path: "/Homepage/EntryPage",
                    query: { isSearch: true }
                  });
                } else if (this.num == 0) {
                  window.open(`${window.pacs_URL}`, "_blank");
                } else {
                  return false;
                }
                cookies.setCookie(
                  "eimageglobaltid",
                  res.data.model.eimageglobaltid
                );
                this.nPassWordNum = 4;
                this.nTime = 300;
              } else {
                //this.msg = res.data.msg;
                let errInfo = res.data.msg;
                if (errInfo === "登录错误次数达5次上限!请5分钟后重试!") {
                  this.$message.error("错误次数以达5次，请五分钟之后再试！");
                  this.loading = false;
                  this.loadText = "登录";
                  return false;
                }
                if (
                  this.nPassWordNum >= 0 &&
                  errInfo.indexOf("未查询到相关信息") > -1
                ) {
                  // 账号不存在，不计次数
                  this.$message.error("用户名或密码错误");
                } else if (
                  this.nPassWordNum >= 0 &&
                  errInfo.indexOf("验证码") > -1
                ) {
                  // 验证码错误不计次数
                  this.$message.error(errInfo);
                } else if (
                  this.nPassWordNum > 0 &&
                  errInfo.indexOf("用户名") > -1
                ) {
                  // 用户名或密码错误
                  let msg = `用户名或密码错误还剩${this.nPassWordNum--}次机会`;
                  this.$message.error(msg);
                }
                message(res.data.msg, false);
              }
              this.verifySrc = `${window.BASE_URL}code.json?${Math.random()}`;
              this.loading = false;
              this.loadText = "登录";
            })
            .catch(() => {
              this.loading = false;
              this.loadText = "登录";
            });
        } else {
          return false;
        }
      });
    },
    tab(index) {
      if (index == 1) {
        message("期待开发", false);
        return;
      }
      this.num = index;
      setTimeout(() => {
        this.isTab = false;
      }, 0);
      setTimeout(() => {
        this.isTab = !this.isTab;
      }, 50);
    },
    _changeVerifyCode() {
      if (this.num == 2) {
        this.verifySrc = `${window.BASE_URL}code.json?${Math.random()}`;
      } else if (this.num == 0) {
        window.open(`${window.pacs_URL}code.json?${Math.random()}`);
      }
    }
  },
  created() {
    this._changeVerifyCode();
  }
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~@/common/css/variable';

.login-leave-active,
.forget-leave-active,
.forget-enter-active,
.login-enter-active {
    transition: transform 1s;
}

.forget-enter,
.login-enter,
.login-leave-to,
.forget-leave-to {
    opacity: 0;
    transform: rotateY(90deg);
}
.login-leave,
.forget-leave,
.forget-enter-to,
.login-enter-to {
    opacity: 1;
    transform: rotateY(0deg);
}

.login-page {
  height: 100%;
  background: #fff;

  .zer-login {
    display: inline-block;
    width:100%;
    height: 414px;
    .log-tab {
      line-height: 40px;
      width: 100%;
      margin-left: 7%;
      font-size: 25px;
      display: inline-block;

      &:after {
        clear: both;
      }

      li {
        float: left;
        cursor: pointer;
        border-radius: 40px 40px 0 0;
        color: #000;
        top: -15px;
        border-bottom: none;
        background: $color-background-d;
        position: relative;

        &:nth-child(2), &:nth-child(3) {
          margin-left: -36px;
        }
      }

      .diagnosis {
        z-index: 2;
        text-align: left;
        padding-left: 40px;
      }

      .consultation {
        z-index: 3;
        text-align: center;
        padding: 0 20px;
      }

      .teaching {
        z-index: 1;
        text-align: right;
        padding-right: 40px;
      }

      .active {
        border: none;
        height: 41px;
        z-index: 300;
        background: #566584;
        bottom: -1px;
        box-shadow: 0 -4px 8px 2px rgba(0, 0, 0, 0.15);
        color: $color-background-d;
      }
    }

    .tabCon {
      height: 240px;
      position: relative;
      width: 100%;
      border-radius: 10px;
      top: -2px;
      background: $color-background-d;
      z-index: 20;
      padding-top: 60px;
      border: 1px solid #E5E5E5;
      padding-bottom: 70px;
      .loginForm {
        transition: all 0.2s ease;

        .loginIcon {
          position: absolute;
          z-index: 10;
          top: 12px;
          left: 10px;
        }

        img {
          display: inline-block;
          width: 35%;
          height: 30px;
          float: right;
          border: 1px solid #E5E5E5;
        }
      }
    }
  }

  .footer {
    width: 400px;
    margin: 0 auto;

    i {
      font-size: 10px;
    }

    .foot-l {
      float: left;
    }

    .foot-r {
      float: right;
    }
  }

  .login-header {
    height: 70px;
    box-sizing: border-box;
    border-bottom: 1px solid $color-background-hover;
    position: relative;

    .zer-log {
      position: absolute;
      bottom: 0;
      left: 10%;
      width: 500px;
      height: 60px;
      background: url('../../../../static/image/log.jpg') no-repeat;
    }
  }

  .choose-sys {
    height: calc(100% - 70px);
    background: url('../../../../static/image/loginBg.png') center bottom no-repeat;
    position: relative;
  }
  .forgetPassword{
    text-align: right;
    cursor:pointer;
    margin-top: 5px;
    padding: 0 10px;
    span{
      // font-weight:bold;
    }
    span:hover{
      color:#00abad;
    }
  }
}
@keyframes bunde-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.forget{
   height: 240px;
      position: absolute;
      width: 100%;
      border-radius: 10px;
      top: 40px;
      background: $color-background-d;
      z-index: 20;
      padding-top: 60px;
      border: 1px solid #E5E5E5;
      padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// login.vue?cd19c776